import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import RadioField from '../../../FormLegacy/FormFieldsV2/RadioField'
import TextAreaField from '../../../FormLegacy/FormFieldsV2/TextAreaField'
import Filter from '../../../Filter/Filter'
import {
  renderSelectBuildingPlaceholder,
  selectBuildingOptions,
  hasOneBuildingAvailable,
} from '../helpers'
import { RecipientLocationFilters } from '../RecipientLocationFilters'
import { useRecipientLocationFilters } from '../useRecipientLocationFilters'

const SmsTemplate = ({
  buildings,
  values,
  isSubmitting,
  isDisabled,
  previewData,
  isDuplicateAnnouncementFormActive,
  userRole,
  handleSubmit,
  handleChange,
  setFieldValue,
}) => {
  const { t } = useTranslation(['organisation', 'surveys'])
  const sendToOptions = [
    {
      id: 0,
      label: t('organisation:communicationPortal.smsTemplate.sendToOptions.all'),
      value: 'all',
    },
    {
      id: 1,
      label: t('organisation:communicationPortal.smsTemplate.sendToOptions.current'),
      value: 'current',
    },
    {
      id: 2,
      label: t('organisation:communicationPortal.smsTemplate.sendToOptions.past'),
      value: 'past',
    },
  ]
  const shouldDisplayBuldingInput = !previewData || isDuplicateAnnouncementFormActive
  const isInputDisabled = isSubmitting || (!!previewData && !isDuplicateAnnouncementFormActive)
  const isSendDisabled = isSubmitting || isDisabled

  const {
    yardiPropertyOptions,
    buildingOptions,
    floorOptions,
    isYardiProperty,
    resetLocationFilters,
  } = useRecipientLocationFilters({
    selectedProperties: values.buildings,
    previewData,
    handleChange,
    setFieldValue,
  })

  const handleBuildingsChange = (e) => {
    handleChange(e)
    resetLocationFilters()
  }

  return (
    <React.Fragment>
      <div className={`main-view sms-inner`}>
        {shouldDisplayBuldingInput ? (
          <div className="field-wrapper property-filters">
            <Filter
              name="buildings"
              placeholder={renderSelectBuildingPlaceholder(values.buildings, t)}
              additionalClass="select-tags-or-buildings-dropdown"
              options={selectBuildingOptions(buildings, userRole, t)}
              value={values.buildings}
              onChange={handleBuildingsChange}
              config={{
                multiple: true,
                hasSearch: true,
              }}
              disabled={hasOneBuildingAvailable(buildings, userRole)}
            />
            <RecipientLocationFilters
              values={values}
              handleChange={handleChange}
              isYardiProperty={isYardiProperty}
              yardiPropertyOptions={yardiPropertyOptions}
              buildingOptions={buildingOptions}
              floorOptions={floorOptions}
            />
          </div>
        ) : null}
        <div className="field-wrapper">
          <div className="recipient-filter__wrap">
            <div className="recipient-filter__text">{t('surveys:recipientsLabel')}</div>
            <div className="recipient-filter">
              <div className="recipient-filter__radio-group">
                {sendToOptions.map(({ id, label, value }) => (
                  <RadioField
                    key={id}
                    name={`sms-${value}-radio`}
                    additionalClass="recipient-filter__radio-group-item"
                    label={label}
                    value={value}
                    checked={values.sendTo === value}
                    disabled={isInputDisabled}
                    onChange={() => handleChange({ target: { name: 'sendTo', value } })}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: 10 }}>
          <TextAreaField
            name="message"
            maxLength="160"
            placeholder={t('organisation:communicationPortal.smsTemplate.messagePlaceholder')}
            value={values.message}
            onChange={handleChange}
            disabled={isInputDisabled}
            rows={7}
          />
        </div>
      </div>
      <div className="window-footer">
        <div className="footer-buttons">
          <button
            type="submit"
            className={`button button-black is-block ${isSubmitting ? 'is-loading' : ''}`}
            onClick={handleSubmit}
            disabled={isSendDisabled}
          >
            {t('organisation:communicationPortal.smsTemplate.send')}
          </button>
        </div>
      </div>
    </React.Fragment>
  )
}

SmsTemplate.propTypes = {
  buildings: PropTypes.array.isRequired,
  values: PropTypes.object,
  isSubmitting: PropTypes.bool,
  isDisabled: PropTypes.bool,
  previewData: PropTypes.object,
  isDuplicateAnnouncementFormActive: PropTypes.bool,
  userRole: PropTypes.string,
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  setFieldValue: PropTypes.func,
}

export default SmsTemplate
